// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608041834/js/" + chunkId + "." + {"44":"dc4a7ab6","225":"8dbf5db2","481":"e8747d6b","486":"cc4e9140","770":"459f31e1"}[chunkId] + ".0.9500325815984387.chunk.js";
};